<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-06-09 09:49:10
 * @LastEditTime: 2020-09-27 09:55:24
 * @Description: 增加编辑公司抽屉
-->
<template>
  <Drawer
    width="400"
    :title="`${openedSac ? '编辑' : '新增'}公司`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="名字" prop="name">
          <Input v-model="formItem.name" placeholder="输入名字..." />
        </FormItem>
        <FormItem label="简称" prop="abbr">
          <Input v-model="formItem.abbr" placeholder="输入简称..." />
        </FormItem>
        <FormItem label="默认工厂" prop="defaultFactory">
          <Select v-model="formItem.defaultFactory" filterable>
            <Option
              v-for="factory in factoryList"
              :value="factory._id"
              :key="factory._id"
              >{{ factory.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "AddCompanyDrawer",
  data() {
    return {
      drawerOpened: false,
      openedSac: undefined,
      formItem: {
        name: null,
        abbr: null,
        defaultFactory: null,
      },
      ruleValidate: {
        name: [{ required: true, message: "公司名为必填项", trigger: "blur" }],
        abbr: [
          { required: true, message: "公司全称为必填项", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      factoryList: (state) => state.factory.factoryList,
    }),
  },
  methods: {
    ...mapActions({
      createCompany: "company/createCompanyAction",
      updateCompany: "company/updateCompanyAction",
      getFactoryList: "factory/getFactorysAction",
    }),
    openDrawer(sac) {
      this.getFactoryList({});
      this.$refs["formItem"].resetFields();
      this.openedSac = sac;
      if (sac) {
        this.formItem.name = this.openedSac.name;
        this.formItem.abbr = this.openedSac.abbr;
        this.formItem.defaultFactory = this.openedSac.defaultFactory;
      }
      this.drawerOpened = true;
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedSac) {
              await this.updateCompany({
                id: this.openedSac._id,
                data: this.formItem,
              });
            } else {
              await this.createCompany(this.formItem);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
};
</script>

<style scoped lang="stylus"></style>
